import React from "react";
import { Link } from "react-router-dom";
import { Phone, MapPin, Clock, Facebook, Instagram, Ghost, Truck } from "lucide-react";
import { restaurant } from "../mock/menuData";

const Footer = () => {
  return (
    <footer className="brick-bg border-t border-white/10 pt-14 pb-8">
      <div className="max-w-7xl mx-auto px-4 grid md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-1 mb-3">
            <span className="font-script text-3xl text-white">M.</span>
            <span className="font-script text-3xl text-pink">Plaisir</span>
          </div>
          <p className="text-white/60 text-sm leading-relaxed">
            {restaurant.tagline} — Snack halal à Marseille. Nouveau propriétaire, nouvelles saveurs. Sandwichs, burgers, tacos & pizzas.
          </p>
          <div className="flex gap-3 mt-4">
            <a href={restaurant.socials.facebook} className="bg-white/10 hover:bg-pink transition-colors rounded-full p-2.5" aria-label="Facebook"><Facebook size={18} /></a>
            <a href={restaurant.socials.instagram} className="bg-white/10 hover:bg-pink transition-colors rounded-full p-2.5" aria-label="Instagram"><Instagram size={18} /></a>
            <a href={restaurant.socials.snapchat} className="bg-white/10 hover:bg-pink transition-colors rounded-full p-2.5" aria-label="Snapchat"><Ghost size={18} /></a>
          </div>
        </div>

        <div>
          <h4 className="font-display text-lg text-gold uppercase mb-4">Navigation</h4>
          <ul className="space-y-2 text-sm text-white/70">
            <li><Link to="/" className="hover:text-pink transition-colors">Accueil</Link></li>
            <li><Link to="/carte" className="hover:text-pink transition-colors">La Carte</Link></li>
            <li><Link to="/carte" className="hover:text-pink transition-colors">Commander</Link></li>
            <li><Link to="/contact" className="hover:text-pink transition-colors">Contact & Horaires</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display text-lg text-gold uppercase mb-4">Contact</h4>
          <ul className="space-y-3 text-sm text-white/70">
            <li className="flex items-start gap-2"><MapPin size={16} className="text-pink mt-0.5 shrink-0" /> {restaurant.address}</li>
            <li className="flex items-center gap-2"><Phone size={16} className="text-pink shrink-0" /> {restaurant.phone}</li>
            <li className="flex items-center gap-2"><Truck size={16} className="text-pink shrink-0" /> Livraison gratuite dès {restaurant.freeDeliveryFrom}€</li>
          </ul>
        </div>

        <div>
          <h4 className="font-display text-lg text-gold uppercase mb-4">Horaires</h4>
          <ul className="space-y-3 text-sm text-white/70">
            {restaurant.hours.map((h) => (
              <li key={h.day} className="flex items-start gap-2">
                <Clock size={16} className="text-pink mt-0.5 shrink-0" />
                <span><span className="text-white">{h.day}</span><br />{h.time}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 mt-10 pt-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-center gap-3 text-xs text-white/40">
        <p>© {new Date().getFullYear()} M.Plaisir by Dragon Food — Tous droits réservés.</p>
      </div>
    </footer>
  );
};

export default Footer;
